import { useQuery } from '@tanstack/react-query';
import GSApi from '../api/Api';
import { VODPurchasesResponse } from '../types/Asset';
import { useAuth } from '../providers/useAuth/AuthContext';

export const useVodPurchasesQuery = (enabled = true) => {
    const { isGuest, authApiInitialized } = useAuth();

    const { data, isLoading, error, refetch, isFetching } = useQuery<VODPurchasesResponse>({
        queryKey: ['vodPurchases'],
        queryFn: async () => {
            const response = await GSApi.getVodPurchases<VODPurchasesResponse>('medium', 1, '2:3');
            if (response.error) {
                throw response.error;
            }
            return response.response;
        },
        enabled: enabled && !isGuest && authApiInitialized,
    });

    return {
        data,
        isLoading,
        isFetching,
        error,
        refetch,
    };
};
